import styled from '@emotion/styled';
import { CVC, EXPIRY, NAME, NUMBER } from '../../constants/field-names';
export var FormGrid = styled.div({
  display: 'grid',
  gridTemplateAreas: "'".concat(NUMBER, " ").concat(NUMBER, "' '").concat(NAME, " ").concat(NAME, "' '").concat(EXPIRY, " ").concat(CVC, "'"),
  gridTemplateColumns: '1fr 1fr',
  gridTemplateRows: 'auto',
  gridColumnGap: "var(--ds-space-200, 16px)",
  gridRowGap: "var(--ds-space-200, 16px)"
});